import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Dropdown from "../../DropDown";
import { validateLomPresidentData } from "../../Validate"; 

const EditLomPresidentModal = ({ show, onClose, president, onSubmit }) => {
  const [formData, setFormData] = useState({
    lomName: "",
    startYear: "",
    endYear: "",
    name: "",
    member_id:"",
    membershipId: "",
    address: "",
    contactNumber: "",
    facebook: "",
    instagram: "",
    youtube: "",
    linkedIn: "",
    isTrainer: false,
    trainer_from_zone_18: "",
    dob:"",
    highest_portfolio: "",
    highest_position_training: "",
    district_id: "",
    district_name:"",
    portfolio_year: "",
    whatsapp_number:"",
  });

  const [errors, setErrors] = useState({});
  const [loms, setLoms] = useState([]);


  const [districtOptions, setDistrictOptions] = useState([]);

  useEffect(() => {
    if (formData.trainer_from_zone_18) {
      fetchDistrictOptions();
    }
  }, [formData.trainer_from_zone_18]);

  const fetchDistrictOptions = async () => {
    try {
      const zoneValue = formData.trainer_from_zone_18;
      const response = await axios.get(`/zone_district/read_zone_18?zone_18=${zoneValue}`);
      const districts = response.data.map((district) => ({
        district_id: district.district_id,
        district_name: district.district_name,
      }));
      setDistrictOptions(districts);
    } catch (error) {
      console.error("Error fetching districts:", error);
      setDistrictOptions([]);
    }
  };

  useEffect(() => {
    if (president) {
      setFormData({
        lom_president_id:president.lom_president_id,
        member_id:president.member_id,
        lomId:president.lomId,
        lomName: president.lomName,
        startYear: president.startYear,
        endYear: president.endYear,
        name: president.name,
        membershipId: president.membershipId,
        address: president.address,
        contactNumber: president.contactNumber,
        whatsapp_number:president.whatsapp_number,
        facebook: president.facebook,
        instagram: president.instagram,
        youtube: president.youtube,
        linkedIn: president.linkedin,
        isTrainer: president.zone_trainer_info.isTrainer,
        trainerZoneXVIII: president.zone_trainer_info.trainerZoneXVIII,
        trainer_from_zone_18:president.zone_trainer_info.trainer_from_zone_18,
        highest_portfolio:president.zone_trainer_info.highest_portfolio,
        highest_position_training:president.zone_trainer_info.highest_position_training,
        district_id: president.zone_trainer_info.district_id,
        dob:president.zone_trainer_info.dob,
        district_name:president.zone_trainer_info.district_name,
        portfolio_year:president.zone_trainer_info.portfolio_year,
        // whatsapp_number:president.zone_trainer_info.whatsapp_number,
      });
    }
  }, [president]);


  useEffect(() => {
    axios
      .get("/lom/read")
      .then((response) => {
        const data = Array.isArray(response.data) ? response.data : [];
        setLoms(data);
      })
      .catch((error) => console.error("Error fetching LOMs:", error));
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Perform validation (you can implement your own validation here)
    const validationErrors = validateLomPresidentData(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      try {
        const response = await axios.put(
          `/lom_president/edit_lom_president/${president.lom_president_id}`,
          formData
        ).then(response => {
            // onSubmit(formData);
            Swal.fire("Success!", "LOM President updated successfully!", "success").then(() => {
              onClose();  // Close the modal or perform other actions
              window.location.reload();  // Reload the page after successful update
            });
      })
      } catch (error) {
        // Safe check for error.response
        const errorMessage = error.response?.data?.error || "Something went wrong";  // Default message
        Swal.fire("Error!", errorMessage, "error");
      }
    }
  };
  

  const resetFormData = () => {
    setFormData({
      lomName: "",
      member_id:"",
      startYear: "",
      endYear: "",
      name: "",
      membershipId: "",
      address: "",
      contactNumber: "",
      facebook: "",
      instagram: "",
      youtube: "",
      linkedIn: "",
      dob:"",
      isTrainer: false,
      whatsapp_number:"",
    });
    setErrors({});
  };

  // Handle "Cancel" button click
  const handleCancel = () => {
    resetFormData();
    onClose();
  };

  // Generate an array of years from current year to 1900
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from(
    { length: currentYear - 1900 + 1 },
    (_, index) => currentYear - index
  );



  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white p-6 max-w-2xl w-full rounded shadow-lg overflow-y-auto max-h-[80vh]">
        <h2 className="text-lg font-bold mb-4">Edit LO</h2>
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* LOM Name */}
            <div>
              <label className="block text-sm font-medium mb-1">LO<span className="text-red-600"> *</span></label>
                <select
                  id="lomDropdown"
                  className="border rounded p-2 w-full"
                  value={formData.lomId}
                  onChange={(event) =>
                    setFormData({ ...formData, lomId: event.target.value })
                  }
                  required
                >
                  <option value="">-- Select an Option --</option>
                  {loms.map((lom) => (
                    <option key={lom.lom_id} value={lom.lom_id}>
                      {lom.lom_name}
                    </option>
                  ))}
                </select>
            </div>

            {/* Name */}
            <div>
              <label className="block text-sm font-medium mb-1">Name with Title</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
              />
              {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
            </div>

            {/* Member ID */}
            <div>
              <label className="block text-sm font-medium mb-1">Member ID</label>
              <input
                type="text"
                name="membershipId"
                value={formData.membershipId}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
              />
              {errors.membershipId && <p className="text-red-500 text-sm">{errors.membershipId}</p>}
            </div>

            {/* Contact Number */}
            <div>
              <label className="block text-sm font-medium mb-1">Contact Number</label>
              <input
                type="text"
                name="contactNumber"
                value={formData.contactNumber}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
              />
              {errors.contactNumber && <p className="text-red-500 text-sm">{errors.contactNumber}</p>}

            </div>
                 {/* Whatsapp and Contact Numbers */}
                 <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Whatsapp Number <span className="text-red-600"> *</span></label>
                <input
                  type="text"
                  name="whatsapp_number"
                  value={formData.whatsapp_number}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                  required
                />
                {errors.whatsapp_number && <p className="text-red-600 text-sm mt-1">{errors.whatsapp_number}</p>}
                {/* <h1>{formData.whatsapp_number}</h1> */}
              </div>

            {/* Period of Presidency */}
            <div className="col-span-2">
            <h3 className="text-sm font-bold mb-4 text-blue-600">Period of Presidency</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {/* Start Year */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  Start Year <span className="text-red-600"> *</span>
                </label>
                <select
                  name="startYear"
                  value={formData.startYear}
                  onChange={handleChange}
                  required
                  className="w-full border rounded px-3 py-2"
                >
                  <option value="">Select Start Year</option>
                  {yearOptions.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
                {errors.startYear && (
                  <p className="text-red-500 text-sm">{errors.startYear}</p>
                )}
              </div>

              {/* End Year */}
              <div>
                <label className="block text-sm font-medium mb-1">
                  End Year <span className="text-red-600"> *</span>
                </label>
                <select
                  name="endYear"
                  value={formData.endYear}
                  onChange={handleChange}
                  required
                  className="w-full border rounded px-3 py-2"
                >
                  <option value="">Select End Year</option>
                  {yearOptions
                    .filter((year) => year >= formData.startYear || !formData.startYear) // Filter end years greater than or equal to start year
                    .map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                </select>
                {errors.endYear && <p className="text-red-500 text-sm">{errors.endYear}</p>}
              </div>
            </div>
          </div>

            {/* Address */}
            <div>
              <label className="block text-sm font-medium text-gray-700">Address</label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
              />
              {errors.address && <p className="text-red-500 text-sm">{errors.address}</p>}
            </div>

            {/* Social Media URLs */}
            <div>
              <label className="block text-sm font-medium mb-1">Facebook</label>
              <input
                type="url"
                name="facebook"
                value={formData.facebook}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
              />
              {errors.facebook && <p className="text-red-500 text-sm">{errors.facebook}</p>}
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Instagram</label>
              <input
                type="url"
                name="instagram"
                value={formData.instagram}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
              />
              {errors.instagram && <p className="text-red-500 text-sm">{errors.instagram}</p>}
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">YouTube</label>
              <input
                type="url"
                name="youtube"
                value={formData.youtube}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
              />
              {errors.youtube && <p className="text-red-500 text-sm">{errors.youtube}</p>}
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">LinkedIn</label>
              <input
                type="url"
                name="linkedIn"
                value={formData.linkedIn}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
              />
              {errors.linkedIn && <p className="text-red-500 text-sm">{errors.linkedIn}</p>}
            </div>
             {/* Trainer */}
             <div className="flex items-center">
              <input
                type="checkbox"
                name="isTrainer"
                checked={formData.isTrainer}
                onChange={handleChange}
                className="mr-2"
              />
              <label className="text-sm font-medium">Whether he/she is a Trainer</label>
              
            </div>
            {/* Show fields only if "isTrainer" is true */}
            {formData.isTrainer && (

            <div>
              {/* Dropdown for Trainer Zone XVIII */}
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Trainer from Zone XVIII (18)<span className="text-red-600"> *</span></label>
                <select
                  name="trainer_from_zone_18"
                  value={formData.trainer_from_zone_18}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                  required
                >
                  <option value="">Select Yes or No</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              {/* <h1>{formData.trainer_from_zone_18}</h1> */}
              {errors.trainer_from_zone_18 && <p className="text-red-600 text-sm mt-1">{errors.trainer_from_zone_18}</p>}
              
              </div>

             
              {/* District Dropdown */}
              {formData.trainer_from_zone_18 === "Yes" && (
                <div className="mb-4">
                  <label className="block mb-2">
                    District<span className="text-red-600"> *</span>
                  </label>
                  <select
                    name="district_id"
                    value={formData.district_id || ""} // Bind the value to formData.district_id
                    onChange={(event) => {
                      const selectedDistrict = districtOptions.find(
                        (district) => district.district_id === parseInt(event.target.value) // Match by district_id
                      );
                      handleChange({
                        target: {
                          name: "district_id",
                          value: event.target.value, // Update district_id in formData
                        },
                      });
                      // handleChange({
                      //   target: {
                      //     name: "district_name",
                      //     value: selectedDistrict ? selectedDistrict.district_name : "", // Update district name in formData
                      //   },
                      // });
                    }}
                    required
                    className="border rounded p-2 w-full"
                  >
                    <option value="" disabled>
                      Select a district
                    </option>
                    {districtOptions.map((district) => (
                      <option key={district.district_id} value={district.district_id}>
                        {district.district_name}
                      </option>
                    ))}
                  </select>
                </div>
              )}
                
              {formData.trainer_from_zone_18 === "No" && (
                  <div className="mb-4">
                    <label className="block mb-2">
                      District<span className="text-red-600"> *</span>
                    </label>
                    <input
                      list="district-options"
                      name="district_id"
                      value={
                        formData.district_id
                          ? districtOptions.find((district) => district.district_id === parseInt(formData.district_id))
                              ?.district_name || formData.district_id
                          : ""
                      }
                      onChange={(event) => {
                        const districtName = event.target.value;
                        const selectedDistrict = districtOptions.find(
                          (district) => district.district_name === districtName
                        );

                        if (selectedDistrict) {
                          handleChange({
                            target: {
                              name: "district_id",
                              value: selectedDistrict.district_id,
                            },
                          });
                        } else {
                          handleChange({
                            target: {
                              name: "district_id",
                              value: districtName,
                            },
                          });
                        }
                      }}
                      onBlur={(event) => {
                        const districtName = event.target.value;
                        const existingDistrict = districtOptions.find(
                          (district) => district.district_name === districtName
                        );

                        if (!existingDistrict && districtName.trim()) {
                          const newDistrictId = districtOptions.length + 1; // Example of unique ID generation
                          const newDistrict = {
                            district_id: newDistrictId,
                            district_name: districtName,
                          };

                          districtOptions.push(newDistrict); // Add to the list dynamically
                          handleChange({
                            target: {
                              name: "district_id",
                              value: newDistrictId,
                            },
                          });
                        }
                      }}
                      required
                      className="border rounded p-2 w-full"
                      placeholder="Select or type a district"
                    />
                    <datalist id="district-options">
                      {districtOptions.map((district) => (
                        <option key={district.district_id} value={district.district_name} />
                      ))}
                    </datalist>
                  </div>
                )}
              {/* Additional Trainer Details */}
              {/* Highest Portfolio */}
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Highest Portfolio in JCI <span className="text-red-600"> *</span></label>
                <input
                  type="text"
                  name="highest_portfolio"
                  value={formData.highest_portfolio}
                  onChange={handleChange}
                  required
                  className="w-full border rounded px-3 py-2"
                />
                {/* <h1>{formData.highest_portfolio}</h1> */}
                {errors.highest_portfolio && <p className="text-red-600 text-sm mt-1">{errors.highest_portfolio}</p>}
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">
                  Portfolio Year <span className="text-red-600"> *</span>
                </label>
                <select
                  name="portfolio_year"
                  value={formData.portfolio_year}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                  required
                >
                  <option value="" disabled>Select Year</option>
                  {Array.from({ length: 50 }, (_, index) => {
                    const year = new Date().getFullYear() - index; // Generate past 50 years
                    return (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    );
                  })}
                </select>
                {/* <h1>{formData.portfolio_year}</h1> */}
                
              </div>
               {/* Area of Training Specialization */}
               <div className="sm:col-span-2 mb-2">
                <label className="block text-sm font-medium mb-1">Area of Training Specialization <span className="text-red-600"> *</span></label>
                <input
                  type="text"
                  name="highest_position_training"
                  value={formData.highest_position_training}
                  onChange={handleChange}
                  required
                  className="w-full border rounded px-3 py-2"
                />
                {/* <h1>{formData.highest_position_training}</h1> */}
                {errors.highest_position_training && <p className="text-red-600 text-sm mt-1">{errors.highest_position_training}</p>}
              </div>
                 {/* Date of Birth */}
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Date of Birth <span className="text-red-600"> *</span></label>
                <input
                  type="date"
                  name="dob"
                  value={formData.dob}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                  required
                />
                {/* <h1>{formData.dob}</h1> */}
                {errors.dob && <p className="text-red-600 text-sm mt-1">{errors.dob}</p>}
              </div>

              {/* Whatsapp and Contact Numbers */}
              {/* <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Whatsapp Number <span className="text-red-600"> *</span></label>
                <input
                  type="text"
                  name="whatsapp_number"
                  value={formData.whatsapp_number}
                  onChange={handleChange}
                  className="w-full border rounded px-3 py-2"
                  required
                />
                {errors.whatsapp_number && <p className="text-red-600 text-sm mt-1">{errors.whatsapp_number}</p>} */}
                {/* <h1>{formData.whatsapp_number}</h1> */}
              {/* </div> */}
            </div>

            )}
          </div>
          <div className="flex justify-end mt-4">
            <button
              type="button"
              onClick={handleCancel}
              className="bg-gray-300 text-black px-4 py-2 rounded mr-2"
            >
              Cancel
            </button>
            <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};



export default EditLomPresidentModal;






